import { ActionType, INotification } from './model'
import { Action, Nullable } from '../model'
import createReducer from '../createReducer'

export interface ICommonReducer {
  lang: string
  notification: Nullable<INotification>
}

const defaultState: ICommonReducer = {
  lang: 'en',
  notification: null,
}

export const commonReducer = createReducer<ICommonReducer>(defaultState, {
  [ActionType.SET_LANG](state: ICommonReducer, action: Action<number>) {
    return { ...state, lang: action.payload }
  },

  [ActionType.SET_NOTIFICATION](state: ICommonReducer, action: Action<Nullable<INotification>>) {
    const { payload } = action
    const anchorOrigin =
      payload?.anchorOrigin ||
      (payload?.size === 'sm' ? { vertical: 'bottom', horizontal: 'center' } : { vertical: 'top', horizontal: 'right' })
    const notification = payload
      ? {
          autoHideDuration: 2000,
          ...payload,
          status: payload?.status || 'success',
          size: payload?.size || 'md',
          anchorOrigin,
        }
      : null

    return {
      ...state,
      notification,
    }
  },
})
